<template>
  <MapPopup
      :loading="loading"
      :data="primaryData"
      :secondary-data="secondaryData"
      :lat="item?.lat"
      :lng="item?.lng"
      show-tabs
      @close="emit('close')"
  >
    <template v-if="item?.lat && item?.lng">
      <div class="map-popup__row">
        <div class="label">{{ $t('front.address') }}</div>
        <div class="value">
          <Address :lat="item.lat" :lng="item.lng" />
        </div>
      </div>
    </template>
  </MapPopup>
</template>
<script setup>
import MapPopup from "@/js/Components/MapPopup/Popup.vue";
import {computed, ref} from "vue";
import {useStore} from "vuex";
import Address from "@/js/Elements/Address.vue";
import {useI18n} from "vue-i18n";

const store = useStore();
const emit = defineEmits(['close']);
const { t } = useI18n();
const props = defineProps({
  id: [Number, String],
});
const id = ref(props.id);
const loading = ref(false);
const filter = computed(() => store.getters['history/filter']);
const historyItem = computed(() => store.getters['history/find'](id.value));
const position = computed(() => store.getters['history-position/positions'][id.value]);
const item = computed(() => {
  if (position.value) return position.value;
  if (!historyItem.value) return;
  return store.getters[`${historyItem.value.type}/find`](historyItem.value.id);
});
const primaryData = computed(() => {
  const data = [];

  if (item.value?.lat) {
    data.push({ title: t('front.latitude'), value: item.value.lat });
  }

  if (item.value?.lng) {
    data.push({ title: t('front.longitude'), value: item.value.lng });
  }

  if (item.value?.start) {
    data.push({ title: t('front.came'), value: item.value.start.datetime });
  }

  if (item.value?.end) {
    data.push({ title: t('front.leave'), value: item.value.end.datetime });
  }

  if (item.value?.metas) {
    Object.values(item.value.metas).forEach((meta) => {
      data.push(meta);
    });
  }

  return data;
});

const secondaryData = computed(() => {
  if (!item.value?.other_arr) return [];
  return item.value.other_arr.map((value) => {
    return { title: null, value };
  })
});

if (!historyItem.value) {
  loading.value = true;
  store.dispatch('history-position/load', {
    device_id: filter.value.device_id,
    position_id: id.value
  }).then((response) => {
    position.value = response;
  }).finally(() => loading.value = false);
}
</script>